var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 17.896,
    height: 24,
    viewBox: "0, 0, 17.896, 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.309,-0 L9.587,-0 L9.587,2.37 L8.309,2.37 L8.309,-0 z",
    fill: "#B0D944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67,3.12 L7.67,3.6 L6.391,3.6 L6.391,4.2 L11.505,4.2 L11.505,3.6 L10.226,3.6 L10.226,2.67 L8.948,2.67 L8.948,3.12 L7.67,3.12 z",
    fill: "#B0D944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.783,4.5 L8.948,4.5 L8.948,4.95 L5.113,4.95 L5.113,6.03 L12.783,6.03 L12.783,4.5 z",
    fill: "#B0D944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.061,6.33 L8.948,6.33 L8.948,6.78 L3.835,6.78 L3.835,7.86 L14.061,7.86 L14.061,6.33 z",
    fill: "#B0D944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.061,8.16 L8.948,8.16 L8.948,8.61 L3.835,8.61 L3.835,9.69 L14.061,9.69 L14.061,8.16 z",
    fill: "#B0D944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.339,9.99 L8.948,9.99 L8.948,10.44 L2.557,10.44 L2.557,11.52 L15.339,11.52 L15.339,9.99 z",
    fill: "#B0D944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.339,11.82 L8.948,11.82 L8.948,12.27 L2.557,12.27 L2.557,13.35 L15.339,13.35 L15.339,11.82 z",
    fill: "#B0D944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.618,13.65 L8.948,13.65 L8.948,14.1 L1.278,14.1 L1.278,15.18 L16.618,15.18 L16.618,13.65 z",
    fill: "#B0D944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.896,15.48 L8.948,15.48 L8.948,15.93 L-0,15.93 L-0,17.01 L17.896,17.01 L17.896,15.48 z",
    fill: "#B0D944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.896,17.31 L8.948,17.31 L8.948,17.76 L-0,17.76 L-0,18.84 L17.896,18.84 L17.896,17.31 z",
    fill: "#B0D944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.896,19.14 L8.948,19.14 L8.948,19.59 L-0,19.59 L-0,20.67 L17.896,20.67 L17.896,19.14 z",
    fill: "#B0D944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.339,20.97 L8.948,20.97 L8.948,21.42 L2.557,21.42 L2.557,22.5 L15.339,22.5 L15.339,20.97 z",
    fill: "#B0D944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.783,22.8 L8.948,22.8 L8.948,23.25 L5.113,23.25 L5.113,24 L12.783,24 L12.783,22.8 z",
    fill: "#B0D944"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPear);
export default __webpack_public_path__ + "static/media/pear.bd6bfa872759c9b14c6c2ffbb870098b.svg";
export { ForwardRef as ReactComponent };